import { ChangeDetectorRef } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { API_CONSTANT } from '../../services/api.constant';
import { HttpClient } from '@angular/common/http';
import { finalize } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
var CustomerRequestComponent = (function () {
    function CustomerRequestComponent(formBuilder, httpClient, translate, cdRef, router, modalService) {
        this.formBuilder = formBuilder;
        this.httpClient = httpClient;
        this.translate = translate;
        this.cdRef = cdRef;
        this.router = router;
        this.modalService = modalService;
        this.language = localStorage.getItem('lang') || 'en';
        this.refreshDropdown = false;
        this.confirmLoading = false;
        this.showError = false;
        this.loading = false;
        this.plusKeyPressed = false;
        this.isThailand = true;
        if (!environment.enabledCustomerRequest) {
            this.router.navigate(['/login']);
        }
    }
    CustomerRequestComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.translate.onLangChange.subscribe(function () {
            _this.translateDropdown();
        });
        this.createBuyerRequestForm();
        this.loadCountries();
    };
    CustomerRequestComponent.prototype.translateDropdown = function () {
        var _this = this;
        this.refreshDropdown = true;
        setTimeout(function () {
            _this.refreshDropdown = false;
        }, 1);
    };
    CustomerRequestComponent.prototype.changeLanguage = function () {
        this.translate.use(this.language);
        localStorage.setItem('lang', this.language);
    };
    CustomerRequestComponent.prototype.handleDocTypeButton = function () {
        this.form.abbNo01.setValue(null);
        this.form.abbNo02.setValue(null);
        this.form.abbNo03.setValue(null);
        this.form.billingNo.setValue(null);
        this.showError = false;
    };
    Object.defineProperty(CustomerRequestComponent.prototype, "invalidAbbNo", {
        get: function () {
            return ((this.form.abbNo01.errors && this.form.abbNo01.errors.required) ||
                (this.form.abbNo02.errors && this.form.abbNo02.errors.required) ||
                (this.form.abbNo03.errors && this.form.abbNo03.errors.required));
        },
        enumerable: true,
        configurable: true
    });
    CustomerRequestComponent.prototype.createBuyerRequestForm = function () {
        this.buyerRequestForm = this.formBuilder.group({
            type: ['hotel', Validators.required],
            abbNo01: [null, Validators.required],
            abbNo02: [null, Validators.required],
            abbNo03: [null, Validators.required],
            billingNo: [null],
            name: [null, Validators.required],
            taxID: [null, [this.validateTaxId, Validators.required]],
            branchCode: [null],
            branchName: [null],
            address: [null, Validators.required],
            subDistrict: [null, Validators.required],
            district: [null, Validators.required],
            province: [null, Validators.required],
            postcode: [null, this.validatePostCode],
            country: [221, Validators.required],
            email: [null, [this.validateEmail, Validators.required]],
            ccEmail: [null],
            phoneNumber: [null, [Validators.required]]
        });
    };
    CustomerRequestComponent.prototype.documentRequestSpaType = function () {
        return this.form.type.value === 'spa';
    };
    CustomerRequestComponent.prototype.validateTaxId = function (control) {
        if (control.value && Boolean(control.value.match(/^[0-9]{13}$/g))) {
            return null;
        }
        return { taxIDInvalid: true };
    };
    CustomerRequestComponent.prototype.validateEmail = function (control) {
        if (control.value) {
            return Validators.email(control);
        }
        return null;
    };
    CustomerRequestComponent.prototype.validatePostCode = function (control) {
        if (control.value && Boolean(control.value.match(/^[0-9]{5}$/g))) {
            return null;
        }
        return { 'postalCodeInvalid': true };
    };
    CustomerRequestComponent.prototype.loadCountries = function () {
        var _this = this;
        this.httpClient.get(API_CONSTANT.country).subscribe(function (res) {
            _this.countries = res;
        });
    };
    Object.defineProperty(CustomerRequestComponent.prototype, "countryCode", {
        get: function () {
            return this.form.country.value;
        },
        enumerable: true,
        configurable: true
    });
    CustomerRequestComponent.prototype.countryChange = function (event) {
        if (event.country_code === 'TH') {
            this.isThailand = true;
            this.form.postcode.setValidators([this.validatePostCode]);
            this.form.taxID.setValidators([this.validateTaxId, Validators.required]);
        }
        else {
            this.isThailand = false;
            this.form.postcode.setValidators([]);
            this.form.taxID.clearValidators();
        }
        this.form.postcode.updateValueAndValidity();
        this.form.taxID.updateValueAndValidity();
    };
    CustomerRequestComponent.prototype.alertSubmitSuccess = function () {
        Swal.fire({
            title: this.translate.instant('CUSTOMER-REQUEST.POPUP-TITLE-SUCCESS'),
            html: this.translate.instant('CUSTOMER-REQUEST.SUBMIT-SUCCESS'),
            type: 'success',
            confirmButtonColor: '#02008a',
            confirmButtonText: this.translate.instant('COMMON.CLOSE'),
            customClass: {
                title: 'custom-title'
            },
            width: '600px'
        });
    };
    CustomerRequestComponent.prototype.alertSubmitFailure = function () {
        Swal.fire({
            title: this.translate.instant('CUSTOMER-REQUEST.POPUP-TITLE-FAILED'),
            text: this.translate.instant('CUSTOMER-REQUEST.SUBMIT-FAILED'),
            type: 'error',
            confirmButtonColor: '#02008a',
            confirmButtonText: this.translate.instant('COMMON.CLOSE'),
            customClass: {
                title: 'text-red'
            }
        });
    };
    CustomerRequestComponent.prototype.formatPhoneNumber = function (event) {
        var valueInput = event.target.value;
        var checkPlus = valueInput.includes('+');
        if (checkPlus) {
            var textValue = valueInput.replace('+', '');
            event.target.value = '+' + textValue;
            this.cdRef.detectChanges();
        }
        else {
            this.plusKeyPressed = false;
        }
    };
    CustomerRequestComponent.prototype.charValidate = function (event) {
        if ((event.charCode >= 48 && event.charCode <= 57) || (event.charCode === 43 && !this.plusKeyPressed)) {
            if (event.charCode === 43) {
                this.plusKeyPressed = true;
            }
            return true;
        }
        return false;
    };
    CustomerRequestComponent.prototype.onSubmit = function (content) {
        this.handleValidatorDocumentSpaType();
        this.showError = false;
        if (this.buyerRequestForm.invalid) {
            this.showError = true;
            return;
        }
        this.modal = this.modalService.open(content, {
            backdrop: 'static',
            keyboard: false,
            centered: true,
            size: 'lg'
        });
    };
    CustomerRequestComponent.prototype.handleValidatorDocumentSpaType = function () {
        var areValidatorsRequired = !this.documentRequestSpaType();
        if (areValidatorsRequired) {
            this.setValidatorsForAbbNos([Validators.required]);
        }
        else {
            this.clearValidatorsForAbbNos();
        }
        this.updateAbbNosValidity();
    };
    CustomerRequestComponent.prototype.setValidatorsForAbbNos = function (validators) {
        this.form.abbNo01.setValidators(validators);
        this.form.abbNo02.setValidators(validators);
        this.form.abbNo03.setValidators(validators);
    };
    CustomerRequestComponent.prototype.clearValidatorsForAbbNos = function () {
        this.form.abbNo01.clearValidators();
        this.form.abbNo02.clearValidators();
        this.form.abbNo03.clearValidators();
    };
    CustomerRequestComponent.prototype.updateAbbNosValidity = function () {
        this.form.abbNo01.updateValueAndValidity();
        this.form.abbNo02.updateValueAndValidity();
        this.form.abbNo03.updateValueAndValidity();
    };
    CustomerRequestComponent.prototype.closePopup = function () {
        this.modal.close();
    };
    CustomerRequestComponent.prototype.submit = function () {
        var _this = this;
        this.loading = true;
        var data = {
            room_type: this.form.type.value,
            confirmation_no: '',
            abb_no: this.documentRequestSpaType() ?
                this.form.billingNo.value : this.form.abbNo01.value + "-" + this.form.abbNo02.value + "-" + this.form.abbNo03.value,
            buyer_name: this.form.name.value,
            tax_id: this.form.taxID.value,
            branch_code: this.form.branchCode.value,
            branch_name: this.form.branchName.value,
            address: this.form.address.value + " " + this.form.subDistrict.value + " " + this.form.district.value + " " + this.form.province.value,
            postal_code: this.form.postcode.value,
            country: this.form.country.value,
            email: this.form.email.value,
            cc_email: this.form.ccEmail.value,
            phone_number: this.form.phoneNumber.value,
        };
        this.httpClient.post(API_CONSTANT.document_request, data)
            .pipe(finalize(function () {
            _this.loading = false;
            _this.showError = false;
        }))
            .subscribe(function () {
            _this.buyerRequestForm.reset();
            _this.form.type.setValue('hotel');
            _this.closePopup();
            _this.alertSubmitSuccess();
        }, function () {
            _this.alertSubmitFailure();
        });
    };
    CustomerRequestComponent.prototype.taxIDChange = function (event) {
        var _this = this;
        var taxID = event.target.value;
        if (!taxID || taxID.length !== 13) {
            return;
        }
        var params = {
            tax_id: taxID
        };
        this.httpClient.get(API_CONSTANT.buyer + "external/", { params: params }).subscribe(function (result) {
            _this.buyerRequestForm.patchValue({
                name: result['name'],
                address: result['address'],
                country: result['country_id'],
                postcode: result['post_code'],
            });
            _this.form.postcode.setValidators([_this.validatePostCode]);
            _this.form.postcode.updateValueAndValidity();
        });
    };
    Object.defineProperty(CustomerRequestComponent.prototype, "form", {
        get: function () {
            return this.buyerRequestForm.controls;
        },
        enumerable: true,
        configurable: true
    });
    return CustomerRequestComponent;
}());
export { CustomerRequestComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/customer-request/customer-request.component.ts.pre-build-optimizer.js